module.exports = __webpack_public_path__ + "img/logo.29491325.svg";